import { CropStyleFillPattern } from "@omnia/shared/generated/enums";
import { IOmniaSession } from "../omnia";
import { ApiCropStyleUpdate, ApiStyle } from "./types";

export class StylesApi {
    constructor(
        readonly session: IOmniaSession,
        readonly refresh: () => PromiseLike<any>,
        readonly http = session.http
    ) {}

    getStyles(): ng.IPromise<ApiStyle[]> {
        const { yearId } = this.session;
        const url = `/api/fields/v2/styles/?year=${yearId}`;

        return this.http.get(url).then((r) => setupStyles(r.data));
    }

    upsertStyles(crops: ApiCropStyleUpdate[]): ng.IPromise<any> {
        const url = `/api/fields/v2/styles`;

        const data = {
            crops,
        };

        return this.http.post(url, data).then((r) => this.refresh());
    }
}

function setupStyles(styles: ApiStyle[]) {
    return (styles || [])
        .filter((x) => Boolean(x.color)) // There are some (old, unsupported) records in the database where `{ color: null, pattern: any }`. Ignore these records.
        .map((s) => ({
            ...s,
            varietyId: s.varietyId || null,
            color: s.color || null,
            pattern: s.pattern || CropStyleFillPattern.None,
            purpose: s.purpose || null,
            grassCuts: s.grassCuts || null,
            grassManagement: s.grassManagement || null,
            croppingCropDescr: s.croppingCropDescr || null,
        }));
}
